
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.999 15.463C.332 9.056 4.179 2.511 10.59.845a11.951 11.951 0 015.48-.132A11.948 11.948 0 008.98.387C2.57 2.053-1.277 8.598.39 15.005c1.184 4.553 4.834 7.811 9.148 8.719a11.977 11.977 0 01-7.538-8.261z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.004 24C18.63 24 24 18.631 24 12.01 24 5.391 18.63.023 12.004.023 5.38.023.008 5.391.008 12.011.008 18.632 5.378 24 12.004 24z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.458 10.855c0-.042.013-.082.034-.118.137-.226.717-1.067 2.108-2.374.906-.852.918-2.226.892-2.7a.237.237 0 01.165-.238c.302-.095.917-.167 1.274.646.446 1.013.372 2.089-.074 3.236a.238.238 0 00.225.325c1.186-.025 2.526-.245 2.993.421.516.736.354 1.327-.181 2.55-.535 1.222-.602 2.692-1.605 3.227-1.004.535-2.083.086-3.43-.162a49.213 49.213 0 00-2.219-.377.238.238 0 01-.204-.223c-.039-.801.014-3.762.022-4.212zM8.324 10.045H7.148a.54.54 0 00-.325.108.5.5 0 00-.202.4v4.158c0 .28.236.508.527.508h1.176a.526.526 0 00.492-.327.488.488 0 00.034-.18v-4.16a.517.517 0 00-.526-.506v-.001zm.002 4.753c-.095 0-.171-.088-.171-.196 0-.107.076-.195.171-.195.095 0 .172.088.172.195 0 .108-.077.196-.172.196zm0-.689c-.095 0-.171-.087-.171-.195 0-.108.076-.195.171-.195.095 0 .172.087.172.195 0 .108-.077.195-.172.195z","fill":"#fff"}})])
          )
        }
      }
    